function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 34,
  fill: "white",
  stroke: "#6F62FF",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.0881 27.0454C37.6775 25.9823 38.0126 24.762 38.0126 23.4643C38.0126 19.3419 34.6307 16 30.4588 16C26.2869 16 22.905 19.3419 22.905 23.4643C22.905 26.365 24.5794 28.8792 27.0253 30.1147V28.543C25.3689 27.4475 24.2784 25.5817 24.2784 23.4643C24.2784 20.0914 27.0455 17.3571 30.4588 17.3571C33.8721 17.3571 36.6392 20.0914 36.6392 23.4643C36.6392 24.7281 36.2507 25.9022 35.5853 26.8765C35.706 26.8637 35.8285 26.8571 35.9525 26.8571C36.3513 26.8571 36.7333 26.9234 37.0881 27.0454ZM33.8924 26.7886C34.742 25.9319 35.2658 24.7585 35.2658 23.4643C35.2658 20.8409 33.1136 18.7143 30.4588 18.7143C27.804 18.7143 25.6518 20.8409 25.6518 23.4643C25.6518 24.7585 26.1757 25.9319 27.0253 26.7886V23.4656C27.0253 21.6035 28.5625 20.0714 30.4588 20.0714C32.3683 20.0714 33.8924 21.5911 33.8924 23.4656V26.7886ZM38.0126 30.2376C38.0126 29.1202 37.0982 28.2143 35.9525 28.2143C34.8147 28.2143 33.8924 29.132 33.8924 30.2376V32.8727V36.3571H32.5189V32.9643V23.476C32.5189 22.3452 31.6045 21.4286 30.4588 21.4286C29.321 21.4286 28.3987 22.333 28.3987 23.476V37.4406C25.5716 34.4543 21.8497 31.1717 20.3244 32.687C18.8312 34.1705 22.6789 38.2581 28.0517 47.1913C30.4725 51.2163 33.5357 53.9994 38.6993 54C44.3882 54 49 49.4429 49 43.8214V39.4064V32.973C49 31.8439 48.0856 30.9286 46.9399 30.9286C45.8021 30.9286 44.8797 31.8466 44.8797 32.973V36.0175V36.3571H43.5063V33.2061V31.5953C43.5063 30.4775 42.5919 29.5714 41.4462 29.5714C40.3084 29.5714 39.386 30.4706 39.386 31.5953V32.9754V35H38.0126V32.9754V30.2376Z",
  fill: "#6F62FF"
});

var SvgOneFinger = function SvgOneFinger(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOneFinger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/one-finger.ad0734fb.svg";
export { ForwardRef as ReactComponent };